export const SCROLL_DELAY = 100;
export const SCROLL_DURATION = 300;
// --- NAV HEIGHT ---
export const SCROLL_OFFSET = -85;
